import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

import '@google/model-viewer'
import '@google/model-viewer-effects'
import * as PostProcessing from "postprocessing";


import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";



export default /*#__PURE__*/_defineComponent({
  __name: 'SharedPageComponent',
  setup(__props) {

const store = useStore();
const route = useRoute();

// Initialize PostProcessing effects
let gridEffect: PostProcessing.GridEffect | null = null;
let sepiaEffect: PostProcessing.SepiaEffect | null = null;


const  shadowIntensity = ref( 0);
const  shadowSoftness = ref( 0);
const  blockOpacity = ref( 1);
const  brightness = ref( 0);
const  contrast = ref( 0);
const  opacity = ref( 1);
const  grid = ref( 0);
const  sepia = ref( 0);
const  blendMode = ref( 'skip');
const  pixar = ref( 0);
const  isSkyBoxImage = ref( 0);
const isEnvImage = ref( 0);

onMounted(async () => {
  await store.dispatch('GET_MAIN_MODEL_IFRAME', route.params.id)
  shadowIntensity.value = Number(route.query.shadowIntensity);
  shadowSoftness.value = Number(route.query.shadowSoftness);
  brightness.value = Number(route.query.brightness);
  contrast.value = Number(route.query.contrast);
  opacity.value = Number(route.query.opacity);
  grid.value = Number(route.query.grid);
  sepia.value = Number(route.query.sepia);
  blendMode.value = String(route.query.blendMode);
  blockOpacity.value = Number(route.query.blockOpacity);
  pixar.value = Number(route.query.pixar);
  isEnvImage.value = Number(route.query.isEnvImage);
  isSkyBoxImage.value = Number(route.query.isSkyBoxImage);

  const customComposer = document.querySelector('effect-composer#customComposer') as any;
  if (!customComposer) {
    console.error('EffectComposer not found');
    return;
  }

  gridEffect = new PostProcessing.GridEffect({scale: grid.value});
  sepiaEffect = new PostProcessing.SepiaEffect();
  sepiaEffect.intensity = sepia.value;

  const noisePass = new PostProcessing.EffectPass(undefined, gridEffect, sepiaEffect);
  customComposer.addPass(noisePass);
})


return (_ctx: any,_cache: any) => {
  const _component_pixelate_effect = _resolveComponent("pixelate-effect")!
  const _component_color_grade_effect = _resolveComponent("color-grade-effect")!
  const _component_effect_composer = _resolveComponent("effect-composer")!
  const _component_model_viewer = _resolveComponent("model-viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_model_viewer, {
      src: _unref(store).getters.MAIN_MODEL_IFRAME,
      "skybox-image": isSkyBoxImage.value ? _unref(store).getters.MAIN_MODEL_IFRAME_SBI : '',
      "environment-image": isEnvImage.value ? _unref(store).getters.MAIN_MODEL_IFRAME_EI : '',
      "shadow-intensity": shadowIntensity.value,
      "shadow-softness": shadowSoftness.value,
      "camera-controls": "",
      "touch-action": "pan-y"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_effect_composer, {
          id: "customComposer",
          "render-mode": "quality",
          msaa: "8"
        }, {
          default: _withCtx(() => [
            (pixar.value)
              ? (_openBlock(), _createBlock(_component_pixelate_effect, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_color_grade_effect, {
              contrast: contrast.value,
              saturation: "-1",
              opacity: opacity.value,
              "blend-mode": blendMode.value,
              brightness: brightness.value
            }, null, 8, ["contrast", "opacity", "blend-mode", "brightness"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["src", "skybox-image", "environment-image", "shadow-intensity", "shadow-softness"])
  ]))
}
}

})